import { ElementType, Suspense } from 'react';
import { useLocation } from 'react-router';
import LoadingScreen from './LoadingScreen';

export const Loadable = (Component: ElementType) => (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export const LocalLoadable = (Component: ElementType) => (props: any) => Loadable(Component)(props);

export default LocalLoadable;
